import { action } from "typesafe-actions";

import { message } from "antd";

import { DateRangePayload, GatePayload, PaginatedResponse, PaginationPayload } from "../common_types";
import { MarketPayload } from "../markets/types";

import { ChartItem, FeedbackItem, FeedbacksActionTypes } from "./types";

export const feedbacksFetchRequest = (payload: DateRangePayload & GatePayload & PaginationPayload & MarketPayload) =>
  action(FeedbacksActionTypes.TABLE_FETCH_REQUEST, payload);

export const feedbacksFetchSuccess = (payload: PaginatedResponse<FeedbackItem>) =>
  action(FeedbacksActionTypes.TABLE_FETCH_SUCCESS, payload);

export const feedbacksFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(FeedbacksActionTypes.TABLE_FETCH_ERROR);
};

export const feedbacksChartFetchRequest = (payload: DateRangePayload & GatePayload & MarketPayload) =>
  action(FeedbacksActionTypes.CHART_FETCH_REQUEST, payload);

export const feedbacksChartFetchSuccess = (payload: ChartItem[]) =>
  action(FeedbacksActionTypes.CHART_FETCH_SUCCESS, payload);

export const feedbacksChartFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(FeedbacksActionTypes.CHART_FETCH_ERROR);
};
